import React, {useEffect, useState} from 'react';
import {Container, Row, Col} from 'reactstrap';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BasicText from '../DebtPaymentComponents/basicText';
import {stepEnum} from '../DebtPaymentComponents/debtPaymentEnum';
import TextInput from '../../../Shared/TextInput/TextInput';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import {CSSTransition} from 'react-transition-group';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import '../debtPayment.scss';
import '../debtPaymentAnimations.scss';

const DebtPaymentContactUs = (props) => {
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [mount, setMount] = useState(false);
  const [textData, setTextData] = useState(props.followUpData);

  useEffect(() => {
    if (props.currentStep === stepEnum.CONTACTUS) {
      setTextData(props.followUpData);
      setMount(true);
      if (props.isPrivate) {
        gaEvent(
          gaParams.PRIVATEDEBT_CONTACTME_SHOW.category,
          gaParams.PRIVATEDEBT_CONTACTME_SHOW.eventType,
          gaParams.PRIVATEDEBT_CONTACTME_SHOW.eventParams,
        );
      } else {
        gaEvent(
          gaParams.DEBT_PAYMENT_SHOW_CONTACTUS.category,
          gaParams.DEBT_PAYMENT_SHOW_CONTACTUS.eventType,
          gaParams.DEBT_PAYMENT_SHOW_CONTACTUS.eventParams,
        );
      }
      props.setContactFormId({
        idNumber: props.idNumber,
        email: props.email,
        phoneNumber: props.phoneNumber,
      });
    } else {
      setMount(false);
    }
  }, [props.currentStep]);

  useExtendedEffect(
    (runSideEffects) => {
      if (runSideEffects()) {
        if (props.email) {
          setEmail(props.email);
        }

        if (props.phone) {
          setPhone(props.phone);
        }
      }
    },
    [props.email, props.phone],
  );

  useEffect(() => {
    if (props.currentStep === stepEnum.CONTACTUS) {
      if (props.formState.valid && props.formState.valid !== '') {
        let followUpObj = props.isPrivate
          ? {
              idNumber: props.savedData.idNumber,
              phoneNumber: props.formState.phoneNumber,
            }
          : {
              account: props.savedData.number,
              orgId: props.chosenOrgId,
              orgType: props.selectedProvider,
              followUpType: props.followUpData.followUpType,
              idNumber: props.savedData.idNumber,
              phoneNumber: props.formState.phoneNumber,
              email: props.formState.email,
            };
        //props.handleCurrentStep(() => props.contactUs(followUpObj));
        props.contactUs(followUpObj);
      }
    }
  }, [props.formState.valid]);

  const emailChangeValidation = (e) => {
    props.changeHandler({target: e.target, form: props.formState});
    setEmail(e.target.value);
  };

  const phoneChangeValidation = (e) => {
    props.changeHandler({target: e.target, form: props.formState});
    setPhone(e.target.value);
  };

  const formSubmmit = () => {
    if (props.isPrivate) {
      gaEvent(
        gaParams.PRIVATEDEBT_CONTACTME_SENTSUCCESS_SHOW.category,
        gaParams.PRIVATEDEBT_CONTACTME_SENTSUCCESS_SHOW.eventType,
        gaParams.PRIVATEDEBT_CONTACTME_SENTSUCCESS_SHOW.eventParams,
      );
    } else {
      gaEvent(
        gaParams.DEBT_PAYMENT_CLICK_CONTACTUS.category,
        gaParams.DEBT_PAYMENT_CLICK_CONTACTUS.eventType,
        gaParams.DEBT_PAYMENT_CLICK_CONTACTUS.eventParams,
      );
    }

    props.validateHandler(props.formState);
  };

  return (
    <CSSTransition key={6} in={mount} timeout={250} classNames='stepwrapper' mountOnEnter unmountOnExit>
      <Container fluid className='debtpayment-step'>
        <Row className='debtpayment-container justify-content-md-center'>
          <Col md='auto'>
            <BasicText text='תשלום חוב' classname='debtpayment-title' />
          </Col>
        </Row>
        <Row className='justify-content-md-center'>
          <Col lg='4'>
            <Row className='debtpayment-step-title justify-content-md-center'>
              <Col>
                <BasicText text={textData.title} classname={'main-text-extra-bold'} />
              </Col>
            </Row>
            <Row className='debtpayment-step-subtitle justify-content-md-center'>
              <Col>
                <BasicText text={textData.text} />
              </Col>
            </Row>
            <Container className='debtpayment-contactus-container'>
              <Row>
                <Col>
                  <BasicText text='שדות עם כוכבית הם חובה' />
                </Col>
              </Row>
              <Row className='justify-content-md-center'>
                <Col>
                  <TextInput
                    pattern='[0-9]*'
                    disabled
                    onChange={(e) =>
                      props.changeHandler({
                        target: e.target,
                        form: props.formState,
                      })
                    }
                    error={props.formState.errors.idNumber}
                    value={props.formState.idNumber}
                    name='idNumber'
                    type='text'
                    placeholder='תעודת זהות'
                    required='required'
                  />
                </Col>
              </Row>
              <Row className='justify-content-md-center'>
                <Col>
                  <TextInput
                    pattern='[0-9]*'
                    onChange={phoneChangeValidation}
                    error={props.formState.errors.phoneNumber}
                    value={props.formState.phoneNumber}
                    name='phoneNumber'
                    type='number'
                    placeholder='נייד'
                    required='required'
                  />
                </Col>
              </Row>
              <Row className='justify-content-md-center'>
                <Col>
                  <TextInput
                    onChange={emailChangeValidation}
                    error={props.formState.errors.email}
                    value={props.formState.email}
                    name='email'
                    type='text'
                    placeholder='כתובת מייל'
                    required='required'
                  />
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
        <Row className='justify-content-md-center footer-btn'>
          <Col md='auto'>
            <BtnSubmit isBusiness={!props.isPrivate} formid='' text='שלח' onclick={() => formSubmmit()} />
          </Col>
        </Row>
      </Container>
    </CSSTransition>
  );
};

export default DebtPaymentContactUs;
